import { Component, OnInit } from '@angular/core';
import { Section } from 'src/app/core/models/DigitalKit';
import { Title } from '@angular/platform-browser';
import $ from 'jquery';
import 'bootstrap';

@Component({
  selector: 'app-infrastructure',
  templateUrl: './infrastructure.component.html',
  styleUrls: ['./infrastructure.component.css'],
  standalone: false
})
export class InfrastructureComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Infraestructura Cloud');
  }

  sections: Section[] = [
    {
      title: 'Migración a la nube',
      description: 'Acompañamos a las empresas en el proceso de migración desde entornos on-premise a la nube, garantizando una transición segura, planificada y sin interrupciones operativas.',
      icon: 'assets/svg/puzzle.svg'
    },
    {
      title: 'Gestión de infraestructura cloud',
      description: 'Administración de entornos cloud (Azure, AWS, GCP): servidores virtuales, almacenamiento, copias de seguridad y servicios gestionados con monitoreo continuo.',
      icon: 'assets/svg/smartphone.svg'
    },
    {
      title: 'Soporte y microinformática',
      description: 'Resolución de incidencias, gestión remota de dispositivos y usuarios, despliegue de software y soporte técnico para garantizar la operatividad diaria del negocio.',
      icon: 'assets/svg/development.svg'
    },
    {
      title: 'Seguridad y continuidad',
      description: 'Implementación de políticas de seguridad, gestión de accesos, backups y planes de recuperación ante desastres para proteger los activos digitales de tu empresa.',
      icon: 'assets/svg/social-media.svg'
    }
  ]

  logos = [
    { src: 'assets/img/microsoft-logo.svg', alt: 'Microsoft' },
    { src: 'assets/img/aws.png', alt: 'AWS' },
    { src: 'assets/img/gcp.svg', alt: 'Google Cloud' }
  ]

  get firstTwoSections() {
    return this.sections.slice(0, 2);
  }

  get lastTwoSections() {
    return this.sections.slice(2, 4);
  }
}
